export const ASSET_REPORT_GENERAL_URL = '/assets/';
export const ASSET_GROUP_REPORT_GENERAL_URL = '/groups/';

const assetsPathRegex = /^\/assets\/[A-Za-z0-9_-]+%7C\d+$/;

const groupsPathRegex = /^\/groups\/[a-f0-9-]{36}\/[A-Za-z0-9_-]+%7C\d+$/i;

export function removeTabAndSubTabFromFilePath(location) {
  let sliceEnd = location?.pathname?.startsWith('/groups/') ? 4 : 3;
  return location?.pathname?.split('/').slice(0, sliceEnd).join('/');
}

export function simplifyUrl(location) {
  const pathname = removeTabAndSubTabFromFilePath(location);

  const [tabName, subTabName] = location.pathname.slice(pathname.length + 1).split('/');
  let simplifiedUrlSuffix = tabName ? (subTabName ? tabName + '&' + subTabName : tabName) : '';
  switch (true) {
    case assetsPathRegex.test(pathname):
      return ASSET_REPORT_GENERAL_URL + simplifiedUrlSuffix;
    case groupsPathRegex.test(pathname):
      return ASSET_GROUP_REPORT_GENERAL_URL + simplifiedUrlSuffix;
    default:
      return pathname;
  }
}
